module.exports = __webpack_public_path__ + "img/logo-landing-mobile.2bcfbde9.svg";